<template>
  <Frontendlayout>
    <section class="hero_in general">
			<div class="wrapper">
				<div class="container">
					<h1 class="fadeInUp"><span></span>{{ userProfile.company_name }}</h1>
				</div>
			</div>
		</section>
  
    <!-- /hero_single -->
    <div class="bg_color_1">
      <nav class="secondary_nav sticky_horizontal">
        <div class="container">
          <ul class="clearfix">
            <li>
              <a href="#description" class="active"
                >About {{ userProfile.company_name }}</a
              >
            </li>
            <li><a href="#reviews">Reviews</a></li>
            <li><a href="#sidebar">Booking</a></li>
          </ul>
        </div>
      </nav>
      <div class="container margin_60_35">
        <div class="row">
          <div class="col-lg-8">
            <section id="description">
              <!-- https://peekzy.in/backend/public/assets/uploads/${userProfile.profile_image} -->
              <h3>{{ offerPost.short_description }}</h3>
              <hr>
              
              <div class="row">
                    <div class="pictures_grid magnific-gallery clearfix">

                      <figure v-for="image in offerPost.images" :key="image.id">
                  <a
                    :href="`https://peekzy.in/backend/public/assets/uploads/offer-images/${image.image}`"
                    title="Photo"
                    data-effect="mfp-zoom-in"
                   
                    ><img
                      :src="`https://peekzy.in/backend/public/assets/uploads/offer-images/${image.image}`"
                  /></a>
                </figure>
                    </div>

                    <div class="col-md-12">
                       <!-- <label>Address :</label> {{ offerPost.location }} -->
                       
                        <div class="description_wrap" style="text-align: justify" v-html="offerPost.description"></div>
                        <label class="col-md-6" style="text-transform:capitalize; color: #fc5b62;font-size: 12px;">{{ offerPost.location }} </label>
                        <label class="col-md-3" style="text-transform:capitalize; color: #fc5b62;font-size: 12px;">{{ offerPost.valid_till }} </label>
                        <label class="col-md-3" style="text-transform:capitalize; color: #fc5b62;font-size: 12px;"><router-link :to="'/merchant/profile/' + userProfile.id">Marchant Profile {{ userProfile.name }}</router-link></label>
                        
                     
                    </div>
                    
                </div>
                 
              <hr>
           
              <div class="row">
								<div class="col-lg-6" v-for="category in offerPost.categories" :key="category.category_id">
									<ul class="bullets">
										<li>{{category.category}}</li>
									</ul>
								</div>
							</div>
              <hr />
              <h6>Pictures from our users</h6>
              <!-- <div class="pictures_grid magnific-gallery clearfix">
                <figure v-for="image in offerPost.images" :key="image.id">
                  <a
                    :href="`https://peekzy.in/backend/public/assets/uploads/${image.image}`"
                    title="Photo"
                    data-effect="mfp-zoom-in"
                    ><img
                      :src="`https://peekzy.in/backend/public/assets/uploads/${image.image}`"
                  /></a>
                </figure>
              
              </div> -->
              <!-- /pictures -->
            <hr />
              
            
            </section>
            <!-- /section -->

            <section id="reviews">
              <h2>Customer Reviews</h2>
             

              <hr />

              <div class="reviews-container">
                
                <!-- /review-box -->
     
                <div class="review-box clearfix" v-for="reviewData in offerReview.reviews" :key="reviewData.id">
                  <figure class="rev-thumb">
                    <img :src="`https://peekzy.in/backend/public/assets/uploads/`+reviewData.user_image" :alt="reviewData.name" />
                  </figure>
                  <div class="rev-content">
                    <div class="rating">
                      <span v-for="i in 5" :key="i">
                        <i v-if="i <= parseInt(reviewData.rating)" class="icon-star voted"></i>
                        <i v-else class="icon-star"></i>
                      </span>
                     
                     
                      
                    </div>
                    <div class="rev-info">{{ reviewData.name }} – {{ reviewData.timestamp }}</div>
                    <div class="rev-text">
                      <p>{{ reviewData.review }}</p>
                    </div>
                  </div>
                </div>
                <!-- /review-box -->
              </div>
              <!-- /review-container -->
            </section>
            <!-- /section -->
            <hr />

            <div class="add-review">
              <h5>Leave a Review</h5>
              <form @submit.prevent="openReviewModal()">
                <div class="row">
                  <!-- <div class="form-group col-md-6">
                    <label>Name</label>
                    <input 
                    disabled
                      type="text"
                      v-model="custReviewName"
                      id="name_review"
                      placeholder=""
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Email</label>
                    <input
                    disabled
                      type="email"
                      v-model="custReviewEmail"
                      id="email_review"
                      class="form-control"
                    />
                  </div> -->
                  <div class="form-group col-md-12">
                    <label>Rating </label>
                    <div class="">
                      <select
                        v-model="custReviewRating"
                        id="rating_review"
                        class="form-control"
                        required
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="form-group col-md-12">
                    <label>Your Review</label>
                    <textarea required
                     v-model="custReviewText"
                      id="review_text"
                      class="form-control"
                      style="height: 130px"
                    ></textarea>
                  </div>
                  <div class="form-group col-md-12 add_top_20">
                    <input
                      type="submit"
                      value="Submit"
                      class="btn_1"
                      id="submit-review"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- /col -->

          <aside class="col-lg-4" id="sidebar">
            <div class="box_detail booking">
              <div class="price">
                <span v-if="offerPost.offer_value">{{offerPost.offer_value}}{{offerPost.offer_in}} <small>Discount </small></span>
           
              </div>
           
              <form @submit.prevent="openLoginModal()">
              <div class="form-group">
								<label for="Offer">Mobile Number</label>
								<input class="form-control" v-model="custMobile" required type="text" />
							</div>
              <div class="form-group">
								<label for="Offer Summary">Customer Summary</label>
								<textarea class="form-control" v-model="custSummary" required rows="4" cols="50"></textarea>							
							</div>
              <button class="btn_1 full-width purchase">Deal With Marchant</button>
              </form>
              <a :href="'tel:'+userProfile.mobile_1" class="btn_1 full-width outline wishlist"
                ><i class="icon_phone"></i> Call Marchant</a
              >

              <!-- <div class="text-center">
                <small>No money charged in this step</small>
              </div> -->
            </div>
            
          </aside>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
      <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
		<Signin/>
    </div>
  </div>
</div>

    </div>
    <!-- /bg_color_1 -->
  </Frontendlayout>
</template>

<script>
/* eslint-disable */

import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import { EventBus } from "@/EventBus";
import Signin from "../components/Signin";

export default {
  created() {
    EventBus.$on("emittedData", (data) => {
      console.log("filter pincode:" + data.search.pincode);
      this.catOptions = data.catList;
      this.subCatOptions = data.subCatList;
    });
  },
  data() {
    return {
      userProfile: {
        company_name: "",
        name: "",
        email: "",
        mobile_1: "",
        id: "",
        pancard: "",
        about_us: "",
        profile_image: "",
        contact_person: "",
      },
      offerPost:{
        short_description : '',
        description : '',
        offer_in : '',
        offer_value : '',
        location : '',
        valid_from : '',
        valid_till : '',
        categories:[],
        images:[],
      },
     
      custSummary:'',
      custMobile:'',
      custReviewRating:'1',
      custReviewText:'',
      ratingStar:'',

      offerReview:{
        reviews:[],
      },
    };
  },
  beforeMount() {
    this.getUserProfile();
    
  },
  mounted(){
    this.checkImagePopup();
  },
  components: {
    Frontendlayout,Signin,
  },

  methods: {
   checkImagePopup(){
window.$('.magnific-gallery').each(function () {
    window.$(this).magnificPopup({
        delegate: 'a',
        type: 'image',
        preloader: true,
        gallery: {
            enabled: true
        },
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
            beforeOpen: function () {
                // just a hack that adds mfp-anim class to markup 
                this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        closeOnContentClick: true,
        midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });
});
   },
    openLoginModal: function () { 
       console.log(this.$route.params);
		const token = localStorage.getItem("token");
      const roleId = localStorage.getItem("role_id");
      if (token != null) {
        if ( roleId != 2) {
      const form = new FormData();
	  form.append("customer_mobile", this.custMobile)
	  form.append("customer_summary", this.custSummary)
          API.post(`/search/offerSingleForm/${this.$route.params.id}`,form, {
        headers: { Authorization: "Bearer "+token },
      })
        .then((res) => {
		  if (res.data.status == 200) {
			this.$swal("success	", res.data.message);  
            //this.$router.push({ name: 'MerchantProfile' })
            this.custMobile = '';
            this.custSummary = '';
          } else {
 		this.$swal(res.data.message);

          }
        })
        .catch((err) => {
          console.log(err.response);
        });
        } else {
		this.$swal("Error", "Only For Customer");
        }
      }else{
		  window.$('.bd-example-modal-lg').modal('show')
	  }
		},
    openReviewModal: function () { 
       console.log(this.$route.params);
		const token = localStorage.getItem("token");
      const roleId = localStorage.getItem("role_id");
      if (token != null) {
        if ( roleId != 2) {
      const form = new FormData();

	  form.append("review_rating", this.custReviewRating)
    form.append("review_text", this.custReviewText)
    form.append("user_image", this.userProfile.profile_image)
    
          API.post(`/search/offerSingleReview/${this.$route.params.id}`,form, {
        headers: { Authorization: "Bearer "+token },
      })
        .then((res) => {
		  if (res.data.status == 200) {
			this.$swal("success	", res.data.message);  
            
          } else {
 		this.$swal(res.data.message);
this.custReviewRating = '';
this.custReviewText = '';
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
        } else {
		this.$swal("Error", "Only For Customer");
        }
      }else{
		  window.$('.bd-example-modal-lg').modal('show')
	  }
		},
    getUserProfile() {
      const firstSegment = new URL(location.href).pathname.split("/")[1];
      const lastSegment = new URL(location.href).pathname.split("/")[3];

      const form = new FormData();
      //alert($(".childcat").is(":checked").val());
      form.append("offer_id", this.$route.params.id);
      form.append("role", firstSegment);

      API({
        method: "post",
        url: "/search/offerSingle",
        data: form,
        auth: {
          username: "testclient",
          password: "testsecret",
        },
      }).then((res) => {
        if (res.data.status == 200) {
          
          this.userProfile.company_name = res.data.data.vendor.company_name;
          this.userProfile.name = res.data.data.vendor.first_name+' '+res.data.data.vendor.last_name;
          this.userProfile.email = res.data.data.vendor.primary_email;
          this.userProfile.mobile_1 = res.data.data.vendor.mobile_1;
          this.userProfile.pancard = res.data.data.vendor.gst_no;
          this.userProfile.id = res.data.data.vendor.id;
          this.userProfile.about_us = res.data.data.vendor.about_us;
          this.userProfile.profile_image = res.data.data.vendor.profile_img;

          this.custReviewName = res.data.data.vendor.first_name+' '+res.data.data.vendor.last_name;
          this.custReviewEmail = res.data.data.vendor.primary_email;


          this.offerPost.short_description = res.data.data.short_description;
          this.offerPost.description = res.data.data.description;
          this.offerPost.offer_in = (res.data.data.offer_in == 'percent') ? '%' : '$';
          this.offerPost.offer_value = res.data.data.offer_value;
          this.offerPost.valid_from = res.data.data.valid_from;
          this.offerPost.valid_till = res.data.data.valid_till;
          this.offerPost.location = res.data.data.location;
          this.offerPost.categories = res.data.data.categories;
          this.offerPost.images = res.data.data.images;
          this.offerReview.reviews = res.data.data.reviews;

          
        } else {
          this.$swal("Error", res.data.messages);
        }
      });
    },
  },
};





</script>


<style  scoped>
.description_wrap > p { margin-bottom : 5px !important; }
@import "../../public/frontend/css/custom.css";

</style>